import * as React from 'react';
import { TextField, Button } from '../common';
import { LoginType } from '../../enums';
import { BaseDialog, BaseDialogProps, BaseDialogState } from '../common/dialog/BaseDialog';
import { Grid2 as Grid } from '@mui/material';

interface Props extends BaseDialogProps {
    readonly loginUser: Entities.User;
    readonly onUpdatePassword: (password: string) => void;
}

interface State extends BaseDialogState {
    readonly password: string;
}

export class AccountDialog extends BaseDialog<Props, State> {
    state = {
        password: '',
    };

    protected renderContent(): React.JSX.Element {
        const { loginUser } = this.props;
        const { password } = this.state;

        return (
            <Grid container={true} spacing={0}>
                <Grid size={12}>
                    <TextField
                        label={'User Name'}
                        fullWidth={true}
                        value={loginUser.username}
                        disabled={true}
                    />
                </Grid>
                {this.enablePassword() && (
                    <>
                        <Grid size={12}>
                            <TextField
                                label={'Password'}
                                fullWidth={true}
                                error={!this.validatePassword()}
                                value={password}
                                type="password"
                                required={true}
                                onChange={this.updatePassword}
                            />
                        </Grid>
                    </>
                )}
                <Grid size={12}>
                    <TextField
                        label={'Name'}
                        fullWidth={true}
                        value={loginUser.name}
                        disabled={true}
                    />
                </Grid>
                <Grid size={12}>
                    <TextField
                        label={'Organization'}
                        fullWidth={true}
                        value={loginUser.organization}
                        disabled={true}
                    />
                </Grid>
            </Grid>
        );
    }

    protected renderActions(): React.JSX.Element {
        return (
            <>
                {this.enablePassword() && (
                    <Button text={'Update Password'} onClick={this.onUpdatePassword} variant="contained" />
                )}
            </>
        );
    }

    private updatePassword = (password: string) => this.setState({ password });

    private validatePassword(): boolean {
        const { password } = this.state;
        return password !== '' && this.props.loginUser.password !== password;
    }

    private onUpdatePassword = () => {
        const { onUpdatePassword } = this.props;
        const { password } = this.state;
        onUpdatePassword(password);
    };

    private enablePassword(): boolean {
        const { loginUser } = this.props;
        return loginUser.loginType !== LoginType.Google;

    }
}
